import { render } from "./UpdateKubernetesSupportedVersion.vue?vue&type=template&id=05bd3b83&scoped=true"
import script from "./UpdateKubernetesSupportedVersion.vue?vue&type=script&lang=js"
export * from "./UpdateKubernetesSupportedVersion.vue?vue&type=script&lang=js"

import "./UpdateKubernetesSupportedVersion.vue?vue&type=style&index=0&id=05bd3b83&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bd3b83"]])

export default __exports__